<template>
  <button :disabled="disabled" :class="[color, variant, disabled]" @click="onclick">
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '',
      validator: function(value) {
        return ['', 'primary', 'secondary', 'danger'].indexOf(value) !== -1;
      }
    },
    variant: {
      type: String,
      default: 'contained',
      validator(value) {
        return ['contained', 'text'].indexOf(value) !== -1;
      }
    },
    disabled: {
      type: Boolean
    }
  },
  methods: {
    onclick(e) {
      this.$emit('click', e);
    }
  }
};
</script>

<style lang="scss" scoped="true">
button {
  outline: none;
  padding: 8px 12px;
  font-size: 0.85rem;
  letter-spacing: 0.025em;
  font-weight: 500;
  border-radius: 2px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  user-select: none;

  &[disabled] {
    opacity: 0.7;
    cursor: not-allowed;
  }

  &.contained {
    color: var(--theme-on-default);
    background-color: transparent;
    border: 1px solid transparent;

    &:not([disabled]) {
      transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
    }

    &.primary {
      color: var(--theme-on-primary);
      background-color: var(--theme-primary);
      border-color: var(--theme-primary);

      &:not([disabled]) {
        &:hover {
          background-color: var(--theme-primary-dark);
          border-color: var(--theme-primary-dark);
        }
      }
    }

    &.danger {
      color: var(--theme-on-danger);
      background-color: var(--theme-danger);
      border-color: var(--theme-danger);

      &:not([disabled]) {
        &:hover {
          background-color: var(--theme-danger-dark);
          border-color: var(--theme-danger-dark);
        }
      }
    }

    &.secondary {
      color: var(--theme-on-secondary);
      background-color: var(--theme-secondary);
      border-color: var(--theme-secondary);

      &:not([disabled]) {
        &:hover {
          background-color: var(--theme-secondary-dark);
          border-color: var(--theme-secondary-dark);
        }
      }
    }

    &:not([disabled]) {
      &:hover {
        cursor: pointer;
        background-color: var(--theme-default-dark);
      }
    }
  }

  &.text {
    border: 1px solid transparent;
    background-color: transparent;
    color: var(--theme-on-background);
    padding: 0.05rem 0.5rem;
    transition: color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, border 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;

    &:not([disabled]) {
      &:hover {
        cursor: pointer;
        color: var(--theme-on-background-dark);
      }
    }

    &.primary {
      color: var(--theme-primary);

      &:not([disabled]) {
        &:hover {
          color: var(--theme-primary-light);
        }
      }
    }

    &.secondary {
      color: var(--theme-secondary);

      &:not([disabled]) {
        &:hover {
          color: var(--theme-secondary-light);
        }
      }
    }

    &.danger {
      color: var(--theme-danger);

      &:not([disabled]) {
        &:hover {
          color: var(--theme-danger-light);
        }
      }
    }
  }
}
</style>
